import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filteredNavData: [],
};

const leadreportfilteredSlice = createSlice({
  name: 'leadreportfiltered',
  initialState,
  reducers: {
    setFilteredNavData: (state, action) => {
      state.filteredNavData = action.payload;
    },
    clearsetFilteredNavData: (state) => {
      state.filteredNavData = [];
    },
  },
});

export const { setFilteredNavData, clearsetFilteredNavData } = leadreportfilteredSlice.actions;
export default leadreportfilteredSlice.reducer;
